/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_05_Detail_Beginner_1_HeadingInputs */

const en_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feel the sequence`)
};

const es_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siente la secuencia`)
};

const de_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spüren Sie die Abfolge`)
};

const zh_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`感受发力顺序`)
};

const ar_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشعر بالتسلسل`)
};

const fr_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressentez la séquence`)
};

const vi_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cảm nhận chuỗi`)
};

const sw_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hisi mfuatano wa mwendo`)
};

const th_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รู้สึกถึงลำดับการเคลื่อนไหว`)
};

const bs_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osjeti sekvencu`)
};

const ja_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順序を感じる`)
};

const ko_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순서를 느껴 보세요`)
};

const pt_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinta a sequência`)
};

const it_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senti la sequenza`)
};

const sv_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Känn sekvensen`)
};

const nl_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voel de volgorde`)
};

const da_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mærk sekvensen`)
};

const nb_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kjenn sekvensen`)
};

const fi_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunne liikesarja`)
};

const pl_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poczuj sekwencję`)
};

const ru_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почувствуйте последовательность`)
};

const tr_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hareket sırasını hissedin`)
};

const hi_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्रम को महसूस कीजिए`)
};

const id_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rasakan urutan gerakannya`)
};

const ms_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rasai urutan gerakannya`)
};

const cs_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vnímejte sled pohybů`)
};

const el_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νιώστε την ακολουθία`)
};

const he_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הרגישו את הרצף`)
};

const af_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voel die volgorde`)
};

const hu_method_content_step_05_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Érezd a mozgássort`)
};

/**
* | output |
* | --- |
* | "Feel the sequence" |
*
* @param {Method_Content_Step_05_Detail_Beginner_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_05_detail_beginner_1_heading = /** @type {((inputs?: Method_Content_Step_05_Detail_Beginner_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_05_Detail_Beginner_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "de") return de_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "th") return th_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "it") return it_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "da") return da_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "id") return id_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "el") return el_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "he") return he_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "af") return af_method_content_step_05_detail_beginner_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_05_detail_beginner_1_heading(inputs)
	return en_method_content_step_05_detail_beginner_1_heading(inputs)
});